import { useEffect } from "react";
import { ContainerV2, H1, P } from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { FormaPagamentoEnum } from "../../../enums/formaPagamento";
import { usePaymentV2 } from "./usePaymentV2";

export const PaymentV2 = () => {
  const {
    stepIndicator,
    formaPagamento,
    handleSelecionar,
    handlePagarAgora,
    podeConfirmar,
    isPending,
  } = usePaymentV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/pagamento:pageview");
  }, []);

  return (
    <ContainerV2
      nextButton={{
        title: "Pagar agora",
        disabled: !podeConfirmar || isPending,
        onClick: handlePagarAgora,
        iconPosition: "left",
        icon: (
          <img
            src="/assets/svgs/icon-verified-user-white.svg"
            alt=""
            className="h-3.5 w-3.5"
          />
        ),
      }}
    >
      {stepIndicator}
      <H1 className="mb-2 mt-8">Pagamento</H1>
      <P className="mb-6 text-[#666666]">
        Após a aprovação você irá definir a data e horário.
      </P>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <label
          className={`flex cursor-pointer flex-col gap-3 rounded-3xl border border-solid bg-white p-6 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)] ${
            formaPagamento === FormaPagamentoEnum.PIX
              ? "border-[#6fa599]"
              : "border-[#e5e5ea]"
          }`}
        >
          <input
            type="radio"
            name="formaPagamento"
            className="sr-only"
            checked={formaPagamento === FormaPagamentoEnum.PIX}
            onChange={() => handleSelecionar(FormaPagamentoEnum.PIX)}
          />
          <div className="flex items-center gap-2">
            <img
              src="/assets/svgs/icon-payment-pix.svg"
              alt=""
              className="h-[26px] w-[26px]"
            />
            <span className="font-['Mulish'] text-xl font-extrabold text-[#20332f]">
              PIX
            </span>
          </div>
          <p className="font-['Mulish'] text-sm text-[#666666]">
            Aprovação instantânea e processamento imediato do seu pedido.
          </p>
          <span className="inline-flex w-fit items-center gap-2 rounded-lg bg-[#e7f7f4] px-3 py-2 text-xs text-[#20332f]">
            <img
              src="/assets/svgs/icon-info-circle-outline.svg"
              alt=""
              className="h-3.5 w-3.5"
            />
            Confirmado em poucos segundos
          </span>
        </label>

        <label
          className={`flex cursor-pointer flex-col gap-3 rounded-3xl border border-solid bg-white p-6 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)] ${
            formaPagamento === FormaPagamentoEnum.BOLETO
              ? "border-[#6fa599]"
              : "border-[#e5e5ea]"
          }`}
        >
          <input
            type="radio"
            name="formaPagamento"
            className="sr-only"
            checked={formaPagamento === FormaPagamentoEnum.BOLETO}
            onChange={() => handleSelecionar(FormaPagamentoEnum.BOLETO)}
          />
          <div className="flex items-center gap-2">
            <img
              src="/assets/svgs/icon-payment-boleto.svg"
              alt=""
              className="h-[26px] w-8"
            />
            <span className="font-['Mulish'] text-xl font-extrabold text-[#20332f]">
              Boleto
            </span>
          </div>
          <p className="font-['Mulish'] text-sm text-[#666666]">
            Vencimento em 3 dias úteis. A aprovação pode levar até 48h.
          </p>
        </label>
      </div>
    </ContainerV2>
  );
};
